import { CabifyProcessStateType, FleetDataType } from 'src/core/models'
import { PayloadAction } from '@reduxjs/toolkit'
import { initialState } from './state'
import { CalculateResultsType } from 'src/core/models/'

const reducers = {
  /* Fleet List Reducers */
  setFleetLoading: (state: CabifyProcessStateType, action: PayloadAction<boolean>) => {
    state.fleetState.loading = action.payload
  },
  setFleetData: (state: CabifyProcessStateType, action: PayloadAction<FleetDataType[]>) => {
    state.fleetState.data = action.payload
  },
  setFleetSuccessCreate: (state: CabifyProcessStateType, action: PayloadAction<boolean>) => {
    state.fleetState.successCreate = action.payload
  },
  setFleetSuccessDelete: (state: CabifyProcessStateType, action: PayloadAction<boolean>) => {
    state.fleetState.successDelete = action.payload
  },
  setFleetError: (state: CabifyProcessStateType, action: PayloadAction<any>) => {
    state.fleetState.error = action.payload
  },
  resetFileSelector: (state: CabifyProcessStateType) => {
    state.fleetState = initialState.fleetState
  },

  /* Calculate Footprint Reducers */
  setCalculateFootprintLoading: (state: CabifyProcessStateType, action: PayloadAction<boolean>) => {
    state.calculateFootprint.loading = action.payload
  },
  setCalculateFootprintError: (state: CabifyProcessStateType, action: PayloadAction<string>) => {
    state.calculateFootprint.error = action.payload
  },
  setCalculateFootprintResults: (state: CabifyProcessStateType,
    action: PayloadAction<CalculateResultsType[]>) => {
    state.calculateFootprint.results = action.payload
  },
  resetCalculateFootprint: (state: CabifyProcessStateType) => {
    state.calculateFootprint = initialState.calculateFootprint
  },

  /* Download File Reducers */
  setDownloadFileLoading: (state: CabifyProcessStateType, action: PayloadAction<boolean>) => {
    state.downloadFile.loading = action.payload
  },
  setDownloadFileError: (state: CabifyProcessStateType, action: PayloadAction<string>) => {
    state.downloadFile.error = action.payload
  },
  setDownloadFileFileUrl: (state: CabifyProcessStateType,  action: PayloadAction<string>) => {
    state.downloadFile.fileUrl = action.payload
  },
}

export default reducers
